module.exports = __webpack_public_path__ + "img/Group 4642.fd074a97.png";